const IMAGES_BASE_URL = '/assets';
const GEOLOCATION_SETTINGS_URL = 'geolocation-settings';

export const IMAGES = {
  android1: {
    en: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/android1_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/android1_de.png`,
      import.meta.url
    ).href
  },
  android2: {
    en: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/android2_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/android2_de.png`,
      import.meta.url
    ).href
  },
  android3: {
    en: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/android3_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/android3_de.png`,
      import.meta.url
    ).href
  },
  ios1: {
    en: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/ios1_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/ios1_de.png`,
      import.meta.url
    ).href
  },
  ios2: {
    en: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/ios2_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/ios2_de.png`,
      import.meta.url
    ).href
  },
  ios3: {
    en: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/ios3_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/app-installation-images/ios3_de.png`,
      import.meta.url
    ).href
  },
  // New Zenjob PRO brand wordmarks (blue + light/white). Kept the existing keys so call
  // sites keep working; consider renaming to logoPrimary/logoLight in a later cleanup.
  proLogoPurple: new URL(`${IMAGES_BASE_URL}/logo-primary.png`, import.meta.url)
    .href,
  proLogoWhite: new URL(`${IMAGES_BASE_URL}/logo-light.png`, import.meta.url)
    .href,
  cloudface: new URL(`${IMAGES_BASE_URL}/cloudface.png`, import.meta.url).href,
  cardHeaderBackground: new URL(
    `${IMAGES_BASE_URL}/card_header_background.png`,
    import.meta.url
  ).href
};

export const GEOLOCATION_SETTINGS_IMAGES = {
  android1: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android1_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android1_de.png`,
      import.meta.url
    ).href
  },
  android2: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android2_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android2_de.png`,
      import.meta.url
    ).href
  },
  android3: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android3_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android3_de.png`,
      import.meta.url
    ).href
  },
  android4: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android4_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android4_de.png`,
      import.meta.url
    ).href
  },
  android5: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android5_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android5_de.png`,
      import.meta.url
    ).href
  },
  android6: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android6_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android6_de.png`,
      import.meta.url
    ).href
  },
  android7: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android7_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android7_de.png`,
      import.meta.url
    ).href
  },
  android8: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android8_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android8_de.png`,
      import.meta.url
    ).href
  },
  android9: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android9_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android9_de.png`,
      import.meta.url
    ).href
  },
  android10: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android10_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android10_de.png`,
      import.meta.url
    ).href
  },
  android11: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android11_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android11_de.png`,
      import.meta.url
    ).href
  },
  android12: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android12_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android12_de.png`,
      import.meta.url
    ).href
  },
  android13: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android13_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android13_de.png`,
      import.meta.url
    ).href
  },
  android14: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android14_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/android14_de.png`,
      import.meta.url
    ).href
  },
  ios1: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios1_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios1_de.png`,
      import.meta.url
    ).href
  },
  ios2: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios2_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios2_de.png`,
      import.meta.url
    ).href
  },
  ios3: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios3_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios3_de.png`,
      import.meta.url
    ).href
  },
  ios4: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios4_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios4_de.png`,
      import.meta.url
    ).href
  },
  ios5: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios5_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios5_de.png`,
      import.meta.url
    ).href
  },
  ios6: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios6_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios6_de.png`,
      import.meta.url
    ).href
  },
  ios7: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios7_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios7_de.png`,
      import.meta.url
    ).href
  },
  ios8: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios8_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios8_de.png`,
      import.meta.url
    ).href
  },
  ios9: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios9_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios9_de.png`,
      import.meta.url
    ).href
  },
  ios10: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios10_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios10_de.png`,
      import.meta.url
    ).href
  },
  ios11: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios11_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/ios11_de.png`,
      import.meta.url
    ).href
  },
  desktop1: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop1_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop1_de.png`,
      import.meta.url
    ).href
  },
  desktop2: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop2_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop2_de.png`,
      import.meta.url
    ).href
  },
  desktop3: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop3_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop3_de.png`,
      import.meta.url
    ).href
  },
  desktop4: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop4_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop4_de.png`,
      import.meta.url
    ).href
  },
  desktop5: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop5_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop5_de.png`,
      import.meta.url
    ).href
  },
  desktop6: {
    en: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop6_en.png`,
      import.meta.url
    ).href,
    de: new URL(
      `${IMAGES_BASE_URL}/${GEOLOCATION_SETTINGS_URL}/desktop6_de.png`,
      import.meta.url
    ).href
  }
};
